import { Modal } from './Modal'
import { AlertTriangle } from 'lucide-react'

interface ConfirmDialogProps {
  acik: boolean
  baslik: string
  mesaj: string
  onayMetni?: string
  iptalMetni?: string
  tehlikeli?: boolean
  onOnay: () => void
  onIptal: () => void
}

export function ConfirmDialog({
  acik,
  baslik,
  mesaj,
  onayMetni = 'Onayla',
  iptalMetni = 'İptal',
  tehlikeli = false,
  onOnay,
  onIptal,
}: ConfirmDialogProps) {
  return (
    <Modal acik={acik} onKapat={onIptal} baslik={baslik}>
      <div className="space-y-4">
        <div className="flex gap-3">
          {tehlikeli && (
            <AlertTriangle className="w-6 h-6 text-amber-500 flex-shrink-0" />
          )}
          <p className="text-gray-700">{mesaj}</p>
        </div>

        <div className="flex gap-2 pt-2">
          <button onClick={onIptal} className="btn-secondary flex-1">
            {iptalMetni}
          </button>
          <button
            onClick={onOnay}
            className={tehlikeli ? 'btn-danger flex-1' : 'btn-primary flex-1'}
          >
            {onayMetni}
          </button>
        </div>
      </div>
    </Modal>
  )
}
